export const  PUBLISHABLE_KEY= process.env.REACT_APP_PUBLISHABLE_KEY
export const  API_URL= process.env.REACT_APP_API_URL
export const trackingID = process.env.REACT_APP_GA_TRACKING_ID;

// export const API_CLIENT_URL = process.env.API_CLIENT_URL